import { ErrorCode } from '@operations/utils/ErrorCode/error-code-enum'
import { useTranslate } from '@tolgee/react'
import { getAllErrorDescriptions } from '@tom-ui/utils'

export const useStoppageReasonMessageHandler = () => {
  const { t } = useTranslate()
  const getExceptionMessage = (error: any) => {
    const errorDescriptions = getAllErrorDescriptions(error)

    const errors: string[] = []

    errorDescriptions.forEach(errorDescription => {
      if (errorDescription.code === ErrorCode.EntityNotFound) {
        errors.push(
          t('entityNotFound', '{entity} with Id {id} not found', {
            entity: errorDescription.payload?.name,
            id: errorDescription.payload?.id,
          }),
        )
      } else if (errorDescription.code === ErrorCode.NameNotUnique) {
        errors.push(
          t('fieldNotUnique', 'The {field} "{name}" already exists', {
            field: t('stoppageReason', 'Stoppage reason'),
            name: errorDescription.payload,
          }),
        )
      } else if (errorDescription.code === ErrorCode.ShortNameNotUnique) {
        errors.push(
          t('fieldNotUnique', 'The {field} "{name}" already exists', {
            field: t('shortName', 'Short name'),
            name: errorDescription.payload,
          }),
        )
      }
    })

    if (errors.length > 0) return errors.join('\n')

    return (
      error?.response?.data?.detail ??
      t('failedToSaveStoppageReason', 'Failed to save stoppage reason')
    )
  }

  const getSuccessMessage = (isEditMode: boolean, name: string) => {
    if (isEditMode) {
      return t('stoppageReasonUpdated', 'Stoppage reason "{name}" updated', { name })
    }
    return t('stoppageReasonCreated', 'Stoppage reason "{name}" created', { name })
  }

  return {
    getExceptionMessage,
    getSuccessMessage,
  }
}
